import React, { useEffect, useMemo, useState } from "react";
import EngagementFilter from "modules/dashboards/engagement_v2/EngagementFilterData";
import { useDoctorSlots } from "pages/store";
import { getTag } from "modules/utilities/utility_2";
import moment from "moment";
import { Table } from "antd";
import DoctorDownload from "./DoctorDownload";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";

function DoctorSlots({
  slots,
  status,
  doctors,
  setStatus,
  setPaymentFilter,
  setDoctorsFilter,
  isLoading,
}) {
  const { setDates } = useDoctorSlots();

  const doctorData = useMemo(() => {
    return slots?.map((item) => {
      return {
        doctor_name: item?.assignment?.first_name,
        name: item?.user?.first_name,
        schedule_At: moment(item?.reminder_date)
          .utcOffset("+05:30")
          .format("YYYY-MM-DD HH:mm:ss"),
        status: getTag(item),
        payment_status: item?.payment_status || "-",
        call_type: item?.booking_type === "clinic_appointment"? "Clinic Aappointment" :  item?.from_crm ? `Intervention Call` : "Consult Call",
        created_at: moment(item?.createdAt)
          .utcOffset("+05:30")
          .format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment(item?.updatedAt)
          .utcOffset("+05:30")
          .format("YYYY-MM-DD HH:mm:ss"),
        case_id:item.case_id        
      };
    });
  }, [slots]);

  const columns = [
    {
      title: "Doctor",
      dataIndex: "doctor_name",
      filters: doctors, 
      filterSearch: true,
      onFilter: (value, record) => {
        if(isEmpty(record?.doctor_name)){
          return false;
        }else{
          const doctorName = record?.doctor_name.toString().toLowerCase(); 
          const strValue = value.toString().toLowerCase(); 
          return doctorName.toLowerCase().startsWith(strValue); 
        }
      }
    },
    {
      title: "Customer Name",
      dataIndex: "name",
      render: (text, record) => (
        <Link to={`/lead-details/${record.case_id}`}>{record.name}</Link>
      ),
    },
    {
      title: "Schedule At",
      dataIndex: "schedule_At",
      sorter: (a, b) => moment(a.schedule_At).diff(moment(b.schedule_At)),
    },
    {
      title: "Status",
      dataIndex: "status",
      filters: [
        { text: "Auto Finished", value: "AUTO FINISHED" },
        { text: "Finished", value: "FINISHED" },
        { text: "Rescheduled", value: "RESCHEDULED" },
        { text: "Not Finished", value: "NOT FINISHED" },
        { text: "Not Answered", value: "NOT ANSWERED" },
      ],
      onFilter: (value, record) => record.status.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      filters: [
        { text: "refund", value: "refund" },
        { text: "expired", value: "expired" },
        { text: "paid", value: "paid" },
        { text: "draft", value: "draft" },
        { text: "failed", value: "failed" },
        { text: "pending", value: "pending" },
        { text: "system", value: "system" },
      ],
      onFilter: (value, record) => record.payment_status.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Call Type",
      dataIndex: "call_type",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      sorter: (a, b) => moment(a.created_at).diff(moment(b.created_at)),
    },
    {
      title: "Last Updated",
      dataIndex: "updated_at",
      sorter: (a, b) => moment(a.updated_at).diff(moment(b.updated_at)),
    },
  ];

  return (
    <div className="mt-2">
      <div className="card p-2">
        <div className="text-center d-flex gap-2 mb-1 align-items-center justify-content-end">
          <DoctorDownload data={slots} />
          <EngagementFilter setDates={setDates} />
        </div>
        <Table
          columns={columns}
          dataSource={doctorData}
          pagination={true}
          style={{ lineHeight: "0.2px", zIndex:'0' }}
        />
      </div>
    </div>
  );
}

export default DoctorSlots;
